// The History Deep Dive (HSC) widget's id, importable without the widget and its routes.
export const HSC_WIDGET_ID = 'data-deep-dive';
